import moment from "moment"
import React, { useEffect, useState } from "react"
import { Badge, Tab, Tabs, Toast, ToastContainer } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import { Assignments, Item } from "../../api/fulfillment.api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import CheckCircleIcon from "../../assets/checkCircleIcon.svg"
import { RootState } from "../../store"
import {
    assignToLocation,
    clearError,
    createParcel,
    loadFulfilledParcels,
    loadFulfillmentRequests,
    loadFulfillmentSuites,
    resetSuccess,
    setTab
} from "../../store/fulfillment.store"
import Header from "../Layout/Header"
import SplitParcelsModal from "../Parcels/SplitParcelsModal"
import CreateParcelModal from "./CreateParcelModal"
// import DateRangePickerCustom from "components/Common/DateRangePicker/DateRangePickerCustom";
import FufillmentRequestsTable from "./FufillmentRequestsTable"

const FufillmentRequests = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { userInfo, defaultWarehouse } = useAppSelector((state: RootState) => state.auth)
    const { fulfillmentRequests, fulfilledParcels, fulfillmentSuites, loading, error, success, tab, barcode } =
        useAppSelector((state: RootState) => state.fulfillments)
    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)

    const [fulfillmentDetails, setFulfillmentDetails] = useState({} as Record<string, any>)
    const [show, setShow] = useState("")

    const [errors, setErrors] = useState({} as Record<string, any>)
    const [parcel, setParcel] = useState({} as Record<string, any>)
    const [reqLoading, setReqLoading] = useState(false)

    const loadAll = async () => {
        await dispatch(
            loadFulfillmentRequests({
                warehouse: selectedWarehouse?.toString() || defaultWarehouse?.toString()
            })
        )
        await dispatch(
            loadFulfilledParcels({
                warehouse: selectedWarehouse?.toString() || defaultWarehouse?.toString()
            })
        )
        await dispatch(
            loadFulfillmentSuites({
                warehouse: selectedWarehouse?.toString() || defaultWarehouse?.toString()
            })
        )
    }

    useEffect(() => {
        if (selectedWarehouse || defaultWarehouse) {
            loadAll()
        }
    }, [selectedWarehouse])

    const handleAssignToLocation = async (data: Record<string, any>) => {
        setReqLoading(true)
        const reqBody = {
            fulfillment_request_id: Number(fulfillmentDetails?.fulfillment_request_id),
            assignments: data?.map((ff: Record<string, any>) => {
                return {
                    fulfillment_suite_id: (
                        (fulfillmentSuites?.find(
                            (ffs: Record<string, any>) => ffs?.suite === Object.keys(ff)[0]
                        ) || {}) as Record<string, any>
                    )?.id,
                    items: Object.values(ff)[0]?.map((i: Record<string, any>) => {
                        return {
                            parcel_item_id: i?.item_id,
                            quantity: i?.quantity
                        }
                    }) as Item[]
                }
            }) as Assignments[]
        }
        await dispatch(assignToLocation(reqBody))
        setShow("")
        setReqLoading(false)
    }

    const handleCreateParcel = async (parcelId: number) => {
        await dispatch(createParcel(parcelId))
        if (barcode && barcode !== "") {
            const barcodeLink = document.createElement("a") as HTMLAnchorElement
            barcodeLink.className = "d-none"
            barcodeLink.href = barcode || ""
            barcodeLink.target = "_blank"
            barcodeLink.click()
        }
        setShow("")
    }

    useEffect(() => {
        if (success) {
            setFulfillmentDetails({})
            loadAll()
            setShow("")
            dispatch(resetSuccess())
        }
    }, [success])

    return (
        <>
            {(!error && loading) || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="fulfilemts-container">
                    {success && (
                        <ToastContainer className="p-3" position={"top-end"}>
                            <Toast onClose={() => dispatch(resetSuccess())}>
                                <Toast.Header closeButton className="bg-light-green border-bottom-0">
                                    <div className="mr-auto d-flex align-items-center">
                                        <img src={CheckCircleIcon} />
                                        <strong className="mx-2 text-black">Success</strong>
                                        <span className="text-black">{t("Changes are saved")}</span>
                                    </div>
                                </Toast.Header>
                            </Toast>
                        </ToastContainer>
                    )}
                    {error?.message && (
                        <ToastContainer className="p-3" position={"top-end"}>
                            <Toast onClose={() => dispatch(clearError())}>
                                <Toast.Header closeButton>
                                    <strong className="me-auto text-danger">Fulfillment Error</strong>
                                    <small>{moment(error?.createdAt?.valueOf()).fromNow()}</small>
                                </Toast.Header>
                                <Toast.Body className="text-danger">{error?.message}</Toast.Body>
                            </Toast>
                        </ToastContainer>
                    )}
                    <Header
                        title={t("Fulfillment")}
                        records={fulfillmentRequests?.length}
                        data={fulfillmentRequests}
                        name="Fulfillment"></Header>
                    <div className="row d-flex tabs-data px-2">
                        <Tabs
                            id="vas-tab"
                            className="mt-4"
                            activeKey={tab}
                            onSelect={(k: any) => {
                                dispatch(setTab(k))
                            }}>
                            <Tab
                                eventKey="fulfillmentRequests"
                                title={
                                    <>
                                        {t("Fulfillment Requests")}
                                        <Badge className="mx-2 px-2">{fulfillmentRequests?.length}</Badge>
                                    </>
                                }>
                                <FufillmentRequestsTable
                                    records={fulfillmentRequests}
                                    fulfillmentDetails={fulfillmentDetails}
                                    setFulfillmentDetails={setFulfillmentDetails}
                                    setErrors={setErrors}
                                    setShow={setShow}
                                />
                            </Tab>
                            <Tab
                                eventKey="fulfilledParcels"
                                title={
                                    <>
                                        {t("Fulfiled Parcels")}
                                        <Badge className="mx-2 px-2">{fulfilledParcels?.length}</Badge>
                                    </>
                                }>
                                <FufillmentRequestsTable
                                    records={fulfilledParcels}
                                    fulfillmentDetails={fulfillmentDetails}
                                    setFulfillmentDetails={setFulfillmentDetails}
                                    setShow={setShow}
                                    setErrors={setErrors}
                                    parcels={true}
                                />
                            </Tab>
                        </Tabs>
                    </div>
                    <SplitParcelsModal
                        show={show}
                        setShow={setShow}
                        handleClose={() => {
                            setFulfillmentDetails({})
                            setShow("")
                        }}
                        data={fulfillmentDetails}
                        handleSubmit={handleAssignToLocation}
                        loading={reqLoading}
                        fulfillmentSuites={fulfillmentSuites}
                    />
                    <CreateParcelModal
                        show={show}
                        setShow={setShow}
                        parcel={fulfillmentDetails}
                        handleCreateParcel={handleCreateParcel}
                    />
                </div>
            )}
        </>
    )
}

export default FufillmentRequests
